import React, { useState, useCallback } from 'react';
import { Popover, TextField, BlockStack } from '@shopify/polaris';
import { HexColorPicker } from 'react-colorful';

/**
 * ColorPicker - A color picker component with hex input
 */
function ColorPicker({ label, color, onChange, disabled = false }) {
  const [popoverActive, setPopoverActive] = useState(false);
  
  const togglePopover = useCallback(() => {
    if (!disabled) {
      setPopoverActive((active) => !active);
    }
  }, [disabled]);
  
  const handleColorChange = useCallback((newColor) => {
    onChange(newColor);
  }, [onChange]);
  
  const handleInputChange = useCallback((value) => {
    // Validate hex color
    if (/^#[0-9A-Fa-f]{0,6}$/.test(value)) {
      onChange(value);
    }
  }, [onChange]);
  
  const activator = (
    <div onClick={togglePopover} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <TextField
        label={label}
        value={color}
        onChange={handleInputChange}
        disabled={disabled}
        prefix={
          <div
            style={{
              width: '24px',
              height: '24px',
              backgroundColor: color,
              borderRadius: '4px',
              border: '1px solid #ddd',
            }}
          />
        }
        readOnly
      />
    </div>
  );
  
  return (
    <Popover
      active={popoverActive}
      activator={activator}
      onClose={() => setPopoverActive(false)}
      preferredAlignment="left"
    >
      <Popover.Section>
        <BlockStack gap="300">
          <HexColorPicker color={color} onChange={handleColorChange} />
          <TextField
            label="Hex Color"
            value={color}
            onChange={handleInputChange}
            autoComplete="off"
          />
        </BlockStack>
      </Popover.Section>
    </Popover>
  );
}

export default ColorPicker;
